import { render, staticRenderFns } from "./SpaceChallengeBox.vue?vue&type=template&id=48bc699e&scoped=true"
import script from "./SpaceChallengeBox.vue?vue&type=script&lang=js"
export * from "./SpaceChallengeBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48bc699e",
  null
  
)

export default component.exports